// graphql.provider.ts
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApplicationConfig, inject } from '@angular/core';
import { ApolloClientOptions, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client/core';
import { ApiUrlService } from '../../../shared/services/api-url-service';

export function apolloOptionsFactory(): ApolloClientOptions<NormalizedCacheObject> {
  const httpLink = inject(HttpLink);
  const apiUrlService = inject(ApiUrlService);

  // link dinamico: ogni chiamata risolve l'URL corrente
  // Se l'operazione porta già una URI nel context (es. forzatura verso un BE specifico), viene rispettata
  const dynamicLink = new ApolloLink((operation, forward) => {
    const existingUri = operation.getContext()['uri'];
    const uri = existingUri || `${apiUrlService.getApiUrl()}graphql`;
    operation.setContext({ uri });
    return forward(operation);
  }).concat(httpLink.create({ uri: '' })); // la URI qui è vuota perché verrà sovrascritta

  return {
    link: dynamicLink,
    cache: new InMemoryCache()
  };
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  Apollo,
  {
    provide: APOLLO_OPTIONS,
    useFactory: apolloOptionsFactory
  }
];
